(function () {
  const bars = document.querySelectorAll('[data-sticky-atc]');
  if (!bars.length || !('IntersectionObserver' in window)) return;

  bars.forEach((bar) => {
    const sectionId = bar.dataset.sectionId;
    const buyButtons = document.querySelector(`#MainProduct-${sectionId} .product-form__buttons`);
    if (!buyButtons) return;

    bar.hidden = false;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { rootMargin: '0px 0px -20% 0px' }
    );

    observer.observe(buyButtons);
  });
})();
